import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const IconContainer = styled.div`
  cursor: pointer;
`;

const Header = styled.div`
  border-bottom: 2px solid ${Colors.line_separator};
`;

const HeaderTopItems = styled.div`
  display: flex;
  padding-top: 21px;
  padding-bottom: 15px;
  padding-left: 41px;
  padding-right: 26px;
  justify-content: center;
  align-items: center;
`;

const TitleContainer = styled.div`
  color: ${Colors.text_primary};
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.01em;
  flex-grow: 1;
`;

const SaveTextContainer = styled.div`
  color: ${Colors.text_primary};
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  cursor: pointer;
  ${(props) =>
    props.saveButtonDisabled &&
    `color: ${Colors.text_primary}30; cursor: not-allowed;`}
`;

const HeaderSecondLineContainer = styled.div`
  padding-top: 27px;
  padding-bottom: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MenuTitleContainer = styled.div`
  color: ${Colors.text_primary};
  height: 25px;
  display: flex;
  align-items: flex-start;
  ${(props) => props.selected && `border-bottom: 2px solid ${Colors.primary};`}
  &:hover {
    border-bottom: 2px solid ${Colors.primary};
  }
  cursor: pointer;
`;

export default {
  IconContainer,
  Header,
  HeaderTopItems,
  TitleContainer,
  SaveTextContainer,
  HeaderSecondLineContainer,
  MenuTitleContainer,
};
